// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"62":"0a7e1caa","74":"c36c0f33","313":"c36c0f33","392":"c36c0f33"}[chunkId] + ".chunk.css";
};